export const normalToMachineTheme = (presetTheme: string): any => {
  let machineTheme = `t2-preset-theme-one`
  if (presetTheme == "Gray") {
    machineTheme = "t2-preset-theme-two"
  } else if (presetTheme == "Black") {
    machineTheme = "t2-preset-theme-three"
  } else if (presetTheme == "Blue") {
    machineTheme = "t2-preset-theme-four"
  } else if (presetTheme == "Dark Blue") {
    machineTheme = "t2-preset-theme-five"
  } else if (presetTheme == "Textured Light") {
    machineTheme = "t2-preset-theme-six"
  } else if (presetTheme == "Textured Dark") {
    machineTheme = "t2-preset-theme-seven"
  }
  return machineTheme
}

export const normalToMachineActionTheme = (presetTheme: string): any => {
  let machineTheme = `t2-action-theme-one`
  if (presetTheme == "Action Black") {
    machineTheme = "t2-action-theme-two"
  } else if (presetTheme == "Action White") {
    machineTheme = "t2-action-theme-three"
  }
  return machineTheme
}

export const colorSettingDetection = (presetTheme: string): any => {
  if (presetTheme == "") {
    return `t2-color-setting--light`
  } // default
  const colorSetting =
    presetTheme == "t2-action-theme-two" ||
    presetTheme == "t2-preset-theme-three" ||
    presetTheme == "t2-preset-theme-four" ||
    presetTheme == "t2-preset-theme-five" ||
    presetTheme == "t2-preset-theme-seven"
      ? `t2-color-setting--dark`
      : `t2-color-setting--light`
  return colorSetting
}

export const truncateText = (text: string, length?: number) => {
  if(!text || !length) {
    return text;
  }
  return text.length > length ? text.slice(0, length) + "..." : text;
};